
export const categories = [
  {
    name: 'Marketing Tools',
    count: 24,
    icon: 'ri-megaphone-line',
    color: 'from-rose-500 to-orange-400',
    image:
      'https://public.readdy.ai/ai/img_res/36a54e37972ae67741d8e64eb3ef3199.jpg'
  },
  {
    name: 'SEO Tools',
    count: 18,
    icon: 'ri-search-eye-line',
    color: 'from-emerald-500 to-teal-400',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20search%20engine%20optimization%20concept%20with%20magnifying%20glass%20and%20data%20charts%20floating%20elements%20green%20and%20teal%20tones%20minimalist%20artistic%20style%20clean%20soft%20gradient%20background%20professional%20illustration&width=400&height=500&seq=cat2&orientation=portrait'
  },
  {
    name: 'Web Hosting',
    count: 12,
    icon: 'ri-server-line',
    color: 'from-amber-500 to-yellow-400',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20cloud%20hosting%20and%20server%20infrastructure%20concept%20with%20floating%20cloud%20icons%20and%20network%20nodes%20warm%20amber%20and%20gold%20tones%20minimalist%20artistic%20style%20clean%20soft%20gradient%20background%20professional%20illustration&width=400&height=500&seq=cat3&orientation=portrait'
  },
  {
    name: 'Web Design',
    count: 15,
    icon: 'ri-layout-masonry-line',
    color: 'from-cyan-500 to-sky-400',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20web%20design%20and%20ui%20ux%20concept%20with%20floating%20browser%20windows%20and%20design%20elements%20cyan%20and%20sky%20tones%20minimalist%20artistic%20style%20clean%20soft%20gradient%20background%20professional%20illustration&width=400&height=500&seq=cat4&orientation=portrait'
  },
  {
    name: 'Business Tools',
    count: 21,
    icon: 'ri-briefcase-line',
    color: 'from-violet-500 to-fuchsia-400',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20business%20productivity%20tools%20concept%20with%20charts%20graphs%20and%20briefcase%20icons%20floating%20violet%20and%20pink%20tones%20minimalist%20artistic%20style%20clean%20soft%20gradient%20background%20professional%20illustration&width=400&height=500&seq=cat5&orientation=portrait'
  },
  {
    name: 'Creative Tools',
    count: 16,
    icon: 'ri-palette-line',
    color: 'from-pink-500 to-rose-400',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20creative%20design%20tools%20concept%20with%20paintbrush%20palette%20and%20artistic%20elements%20floating%20pink%20and%20rose%20tones%20minimalist%20artistic%20style%20clean%20soft%20gradient%20background%20professional%20illustration&width=400&height=500&seq=cat6&orientation=portrait'
  }
];

export const trendingSearches = [
  'Email Marketing',
  'Landing Pages',
  'SEO Audit',
  'CRM Software',
  'Social Media',
  'WordPress Hosting',
  'Video Editing',
  'Project Management'
];

export const featuredDeals = [
  {
    id: '1',
    name: 'Landing Page Builder',
    originalPrice: 99,
    dealPrice: 49,
    discount: 50,
    rating: 4.9,
    reviews: 2341,
    image:
      'https://readdy.ai/api/search-image?query=modern%20landing%20page%20builder%20software%20product%20screenshot%20showing%20drag%20and%20drop%20interface%20with%20beautiful%20templates%20clean%20white%20background%20professional%20product%20photography%20style%20high%20quality&width=400&height=400&seq=deal1&orientation=squarish',
    tag: 'Best Seller'
  },
  {
    id: '2',
    name: 'Email Marketing Suite',
    originalPrice: 79,
    dealPrice: 39,
    discount: 50,
    rating: 4.8,
    reviews: 1876,
    image:
      'https://readdy.ai/api/search-image?query=modern%20email%20marketing%20automation%20software%20product%20screenshot%20showing%20campaign%20dashboard%20with%20analytics%20clean%20white%20background%20professional%20product%20photography%20style%20high%20quality&width=400&height=400&seq=deal2&orientation=squarish',
    tag: 'Popular'
  },
  {
    id: '3',
    name: 'SEO Analytics Pro',
    originalPrice: 129,
    dealPrice: 79,
    discount: 39,
    rating: 4.7,
    reviews: 1543,
    image:
      'https://readdy.ai/api/search-image?query=modern%20seo%20analytics%20software%20product%20screenshot%20showing%20keyword%20research%20dashboard%20with%20graphs%20clean%20white%20background%20professional%20product%20photography%20style%20high%20quality&width=400&height=400&seq=deal3&orientation=squarish',
    tag: 'Top Rated'
  },
  {
    id: '4',
    name: 'Social Media Manager',
    originalPrice: 69,
    dealPrice: 29,
    discount: 58,
    rating: 4.6,
    reviews: 987,
    image:
      'https://readdy.ai/api/search-image?query=modern%20social%20media%20management%20software%20product%20screenshot%20showing%20scheduling%20calendar%20and%20analytics%20clean%20white%20background%20professional%20product%20photography%20style%20high%20quality&width=400&height=400&seq=deal4&orientation=squarish',
    tag: 'Hot Deal'
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'James Carter',
    role: 'Freelance Designer',
    avatar: 'JC',
    text: 'Found the perfect design tools through this site. The reviews are honest and the deals saved me hundreds of dollars on software I actually needed.',
    product: 'Graphic Design Platform',
    rating: 5
  },
  {
    id: '2',
    name: 'Maria Santos',
    role: 'E-commerce Owner',
    avatar: 'MS',
    text: 'I was overwhelmed by all the marketing tools out there. This platform helped me compare options side by side and pick the right ones for my business.',
    product: 'Email Marketing Suite',
    rating: 5
  },
  {
    id: '3',
    name: 'David Kim',
    role: 'Startup Founder',
    avatar: 'DK',
    text: 'The curated product recommendations are spot on. Every tool I discovered here has become essential to running my startup efficiently.',
    product: 'Project Management Tool',
    rating: 5
  }
];

export const topPicks = [
  {
    id: '1',
    name: 'Premium WordPress Hosting',
    category: 'Web Hosting',
    rating: 4.8,
    reviews: 3421,
    price: 'From $3.99/mo',
    highlight: 'Best for speed & reliability',
    image:
      'https://readdy.ai/api/search-image?query=modern%20premium%20web%20hosting%20service%20product%20visual%20with%20server%20and%20cloud%20icons%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top1&orientation=landscape'
  },
  {
    id: '2',
    name: 'Email Marketing Suite',
    category: 'Marketing Tools',
    rating: 4.9,
    reviews: 2876,
    price: 'From $19/mo',
    highlight: 'Best for automation',
    image:
      'https://readdy.ai/api/search-image?query=modern%20email%20marketing%20platform%20product%20visual%20with%20envelope%20icons%20and%20automation%20workflow%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top2&orientation=landscape'
  },
  {
    id: '3',
    name: 'SEO Analytics Pro',
    category: 'SEO Tools',
    rating: 4.7,
    reviews: 1987,
    price: 'From $29/mo',
    highlight: 'Best for keyword research',
    image:
      'https://readdy.ai/api/search-image?query=modern%20seo%20analytics%20tool%20product%20visual%20with%20search%20magnifying%20glass%20and%20chart%20icons%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top3&orientation=landscape'
  },
  {
    id: '4',
    name: 'Landing Page Builder',
    category: 'Web Design',
    rating: 4.9,
    reviews: 4231,
    price: 'From $12/mo',
    highlight: 'Best for conversions',
    image:
      'https://readdy.ai/api/search-image?query=modern%20landing%20page%20builder%20tool%20product%20visual%20with%20website%20template%20icons%20and%20design%20elements%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top4&orientation=landscape'
  },
  {
    id: '5',
    name: 'CRM Software',
    category: 'Business Tools',
    rating: 4.6,
    reviews: 1654,
    price: 'From $15/mo',
    highlight: 'Best for sales teams',
    image:
      'https://readdy.ai/api/search-image?query=modern%20crm%20software%20product%20visual%20with%20contact%20management%20icons%20and%20pipeline%20chart%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top5&orientation=landscape'
  },
  {
    id: '6',
    name: 'Video Editing Software',
    category: 'Creative Tools',
    rating: 4.8,
    reviews: 2943,
    price: 'From $9.99/mo',
    highlight: 'Best for creators',
    image:
      'https://readdy.ai/api/search-image?query=modern%20video%20editing%20software%20product%20visual%20with%20film%20reel%20and%20timeline%20icons%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top6&orientation=landscape'
  },
  {
    id: '7',
    name: 'Project Management Tool',
    category: 'Business Tools',
    rating: 4.8,
    reviews: 3654,
    price: 'From $8/mo',
    highlight: 'Best for teams',
    image:
      'https://readdy.ai/api/search-image?query=modern%20project%20management%20tool%20product%20visual%20with%20task%20board%20and%20collaboration%20icons%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top7&orientation=landscape'
  },
  {
    id: '8',
    name: 'Graphic Design Platform',
    category: 'Creative Tools',
    rating: 4.7,
    reviews: 2789,
    price: 'Free / $12.99/mo',
    highlight: 'Best for beginners',
    image:
      'https://readdy.ai/api/search-image?query=modern%20graphic%20design%20platform%20product%20visual%20with%20paintbrush%20and%20canvas%20icons%20clean%20minimalist%20design%20on%20pure%20white%20background%20professional%20product%20showcase%20style%20high%20quality%20digital%20illustration&width=400&height=300&seq=top8&orientation=landscape'
  }
];

export const comparisonHighlights = [
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Reviews',
    desc: 'Every review is from a real user who purchased the product'
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Side-by-Side Comparisons',
    desc: 'Compare features, pricing, and ratings across similar tools'
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Exclusive Deals',
    desc: 'Access special discounts not available anywhere else'
  },
  {
    icon: 'ri-refresh-line',
    title: 'Updated Weekly',
    desc: 'Our team reviews and updates recommendations every week'
  }
];
